<template>
    <div>
        <rkm-area no-margin-top title="filtros" type="fieldset">
            <rkm-form ref="Form">
                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            v-model="model.periodo"
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            range
                            :start-validations="{ required: true }"
                            :end-validations="{ required: true }"
                            />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            :validations="validations.inep"
                            label="INEP"
                            number
                            v-model="model.inep"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            v-model="model.pseId"
                            :options="pseItens"
                            label="PSE"
                            show-default-option
                            default-option-text="Todas"
                            text-field="descricao"
                            value-field="id"
                            @input="getTurnos"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            v-model="model.turnoId"
                            :options="turnoItens"
                            label="Turno"
                            show-default-option
                            default-option-text="Todos"
                            text-field="descricao"
                            value-field="id"
                            @input="getUnidades"
                        />
                    </rkm-col>           
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            v-model="model.unidadeId"
                            :options="unidadeItens"
                            label="Unidade"
                            show-default-option
                            default-option-text="Todos"
                            text-field="nomeFantasia"
                            value-field="id"
                            @input="getLocaisAtendimentos"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            v-model="model.localAtendimentoId"
                            :options="localAtendimentoItens"
                            label="Local de Atendimento"
                            show-default-option
                            default-option-text="Todos"
                            text-field="nomeFantasia"
                            value-field="id"
                            @input="getProfissionais"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            v-model="model.profissionalId"
                            :options="profissionalItens"
                            label="Profissional"
                            show-default-option
                            default-option-text="Todos"
                            text-field="nome"
                            value-field="id"
                            @input="getOcupacoes"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            v-model="model.ocupacaoId"
                            :options="ocupacaoItens"
                            label="CBO"
                            show-default-option
                            default-option-text="Todos"
                            text-field="nome"
                            value-field="id"
                            @input="getEquipes"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-select
                            v-model="model.equipeId"
                            :options="equipeItens"
                            label="Equipe"
                            show-default-option
                            default-option-text="Todos"
                            text-field="descricao"
                            value-field="id"
                            @input="getAtividades"
                        />
                    </rkm-col>
                    <rkm-col cols="3">
                        <rkm-form-select
                            v-model="model.atividadeId"
                            :options="atividadeItens"
                            label="Atividade"
                            show-default-option
                            default-option-text="Todos"
                            text-field="descricao"
                            value-field="id"
                            @input="getPublicosAlvo"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-multiselect
                            :load-all-automatically="false"
                            :options="publicoAlvoItens"
                            :select-limit="null"
                            label="Público Alvo"
                            option-name-key="descricao"
                            option-text-selecteds="público alvo"
                            v-model="model.publicoAlvoIds"
                            value-field="id"
                            @update:dropdownClosed="getTemasSaude"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-multiselect
                            :load-all-automatically="false"
                            :options="temaSaudeItens"
                            :select-limit="null"
                            label="Temas para saúde"
                            option-name-key="descricao"
                            option-text-selecteds="Tema para saúde"
                            v-model="model.temaSaudeIds"
                            value-field="id"
                             @update:dropdownClosed="getPraticasSaude"
                        />
                    </rkm-col> 

                    <rkm-col cols="3">
                        <rkm-form-multiselect
                            :load-all-automatically="false"
                            :options="praticaSaudeItens"
                            :select-limit="null"
                            @update:dropdownClosed="getProcedimentos()"
                            label="Práticas em saúde"
                            option-name-key="descricao"
                            option-text-selecteds="grupo"
                            v-model="model.praticaSaudeIds"
                            value-field="id"
                            :disabled="praticaSaudeDisabled"
                        />
                    </rkm-col> 

                    <rkm-col cols="3">
                        <rkm-form-multiselect
                            :load-all-automatically="false"
                            :options="procedimentoItens"
                            :select-limit="null"
                            label="Procedimentos"
                            option-name-key="nome"
                            option-text-selecteds="procedimentos"
                            v-model="model.procedimentoIds"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input-autocomplete
                            :repository="{ autocomplete: repositories.relatorioAtividadeColetiva.paciente }"
                            :searchFields="pacienteSearchFields"
                            :text-field="p => p.cns ? `${p.cns} - ${p.nome}` : p.nome"
                            :minLength="3"
                            :request-query-string-params="autocompleteParams"
                            label="Paciente"
                            v-model="model.paciente"
                            value-field="id"
                            placeholder="Nome, Nome social, CNS, CPF, Data de nascimento ou Prontuário"
                        />
                    </rkm-col> 

                    <rkm-col cols="3">
                        <rkm-row class="mt-4">
                            <rkm-col cols="4">
                                <rkm-form-checkbox v-model="model.avaliacaoAlterada" :value="true">
                                    Avaliação alterada
                                </rkm-form-checkbox>
                            </rkm-col>
                            <rkm-col cols="4">
                                <rkm-form-checkbox v-model="model.parouDeFumar" :value="true">
                                    PNCT - Parou de fumar
                                </rkm-form-checkbox>
                            </rkm-col>
                            <rkm-col cols="4">
                                <rkm-form-checkbox v-model="model.abandonouGrupo" :value="true">
                                    PNCT - Abandonou Grupo
                                </rkm-form-checkbox>
                            </rkm-col>
                        </rkm-row>
                    </rkm-col>                        
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-button
                            color="primary"
                            :label="false"
                            @click="search"
                        >
                            Buscar
                        </rkm-button>
                      
                        <rkm-button
                            color="secondary"
                            :label="false"
                            @click="limpar"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            
            </rkm-form>
        </rkm-area>

        <rkm-area v-if="itens.length > 0"
            no-margin-top
            title="Totalizadores"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="2">
                    <rkm-form-input
                        :value="totalizadores.totalAtividades"
                        disabled
                        label="Total de atividades"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="totalizadores.totalProcedimentos"
                        disabled
                        label="Total de procedimentos"
                    />
                </rkm-col>

                <rkm-col cols="2">

                    <rkm-form-input
                        :value="totalizadores.totalPessoasAvaliadas"
                        disabled
                        label="Total de Pessoas avaliadas"
                    />
                </rkm-col>
            </rkm-row>

        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
        <template v-slot:trailing>
            <rkm-dropdown
                class="mr-2"
                color="primary"
                cols="1"
                menu-class="auto-scroll"
                no-caret
                small
                title="Colunas"
                v-rkm-tooltip.hover
            >
                <template v-slot:button-content>
                    <rkm-icon icon="columns" />
                </template>

                <rkm-form-checkbox
                    :indeterminate="indeterminate"
                    @change="selectAll"
                    class="mx-2"
                    v-model="selectedAll"
                >
                    Todas
                </rkm-form-checkbox>

                <rkm-form-checkbox-group
                    :options="optionalColumns"
                    class="mx-2"
                    stacked
                    text-field="label"
                    v-model="selectedCols"
                    value-field="key"
                />

            </rkm-dropdown>

            <rkm-button
                    :disabled="itens.length === 0"
                    @click="print"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
            </rkm-button>

            <rkm-button
                    :disabled="itens.length === 0"
                    @click="exportar"
                    color="info"
                    small
                    title="Exportar para XLS"
                >
                    <rkm-icon icon="file-export" />
            </rkm-button>
        </template>
            <rkm-table
                :fields="fields"
                :items="itens"
                :sort-by="sortBy"
                :sort-desc="sortDesc"
                @sort-changed="onSortChanged"
            >
                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        :disabled="!verificarPermissao('edit-atencao-basica-atividade-coletiva')"
                        @click="openScreen(item)"
                        color="primary"
                        small
                        title="Editar"
                    >
                        <rkm-icon icon="pen" />
                    </rkm-button>
                </template>
            </rkm-table>
    
        </rkm-area>

    </div>
</template>

<script>
import { repository, formats, file, stringCase, permissao } from "@/mixins";
import { mapActions } from "vuex";
import moment from "moment";
import AtividadeTipo from "@/enums/atencao-basica/atividade-coletiva/atividadeTipo";
export default{
    computed: {
        validations() {
            return {
                inep: {
                    max: 8
                }
            }
        },
        praticaSaudeDisabled() {
            return this.model.atividadeId !== AtividadeTipo.AVALIACAO_PROCEDIMENTO_COLETIVO
        },
        optionalColumns() {
            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {
            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        autocompleteParams() {
            return {
                periodo: {
                    data_inicial: this.model.periodo.start ? moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    data_final: this.model.periodo.end ? moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                pse_id: this.model.pseId,
                inep: this.model.inep,
                turno_id: this.model.turnoId,
                unidade_id: this.model.unidadeId,
                local_atendimento_id: this.model.localAtendimentoId,
                profissional_id: this.model.profissionalId,
                publico_alvo_ids: this.model.publicoAlvoIds,
                procedimento_id: this.model.procedimentoIds,
            }
        },
        pacienteSearchFields() {
            return [
                { key: 'cidadao.nome', searchable: true },
                { key: 'cidadao.nome_social', searchable: true },
                { key: 'cidadao.cns', searchable: true },
                { key: 'cidadao.cpf', searchable: true },
                { key: 'cidadao.data_nascimento', searchable: true },
                { key: 'paciente.prontuario', searchable: true },
             ]
        },
        filtrosImpressao() {
            const find = (list, id, field) => {
                const item = list.find(i => i.id === id)
                return item ? item[field] : 'Todos'
            }
            const findMany = (list, ids, field) => {
                if (!ids || !ids.length) return 'Todos'
                return list.filter(i => ids.includes(i.id)).map(i => i[field]).join(', ') || 'Todos'
            }
            return {
                periodo: `${moment(this.model.periodo.start).format('DD/MM/YYYY')} até ${moment(this.model.periodo.end).format('DD/MM/YYYY')}`,
                inep: this.model.inep || 'Todos',
                pse: find(this.pseItens, this.model.pseId, 'descricao'),
                turno: find(this.turnoItens, this.model.turnoId, 'descricao'),
                unidade: find(this.unidadeItens, this.model.unidadeId, 'nomeFantasia'),
                localAtendimento: find(this.localAtendimentoItens, this.model.localAtendimentoId, 'nomeFantasia'),
                profissional: find(this.profissionalItens, this.model.profissionalId, 'nome'),
                cbo: find(this.ocupacaoItens, this.model.ocupacaoId, 'nome'),
                equipe: find(this.equipeItens, this.model.equipeId, 'descricao'),
                atividade: find(this.atividadeItens, this.model.atividadeId, 'descricao'),
                publicoAlvo: findMany(this.publicoAlvoItens, this.model.publicoAlvoIds, 'descricao'),
                temaSaude: findMany(this.temaSaudeItens, this.model.temaSaudeIds, 'descricao'),
                praticaSaude: findMany(this.praticaSaudeItens, this.model.praticaSaudeIds, 'descricao'),
                procedimentos: findMany(this.procedimentoItens, this.model.procedimentoIds, 'nome'),
                paciente: this.model.paciente ? 'Selecionado' : 'Todos',
            }
        },
    },

    created(){
        this.repositories = {
            relatorioAtividadeColetiva: this.getConectaSusRepository("atencaoBasica.relatorioAtividadeColetiva"),
            impressao: this.getConectaSusRepository("impressao.atencaoBasica"),
            exportacao: this.getConectaSusRepository("exportacao.atencaoBasica"),
        }
        this.load()
    },

    data() {
        return {
            form: null,
            model: {
                periodo: {
                    start: null,
                    end: null
                },
                pseId: null,
                turnoId: null,
                inep: null,
                unidadeId: null,
                localAtendimentoId: null,
                profissionalId: null,
                ocupacaoId: null,
                equipeId: null,
                atividadeId: null,
                paciente: null,
                publicoAlvoIds: [],
                temaSaudeIds: [],
                praticaSaudeIds:[],
                procedimentoIds:[],
                avaliacaoAlterada: false,
                parouDeFumar: false,
                abandonouGrupo: false,
            },
            turnoItens: [],
            pseItens: [],
            unidadeItens: [],
            localAtendimentoItens: [],
            profissionalItens: [],
            ocupacaoItens: [],
            equipeItens: [],
            atividadeItens: [],
            publicoAlvoItens: [],
            temaSaudeItens: [],
            praticaSaudeItens: [],
            procedimentoItens: [],
            itens: [],
            totalizadores: [],
            sortBy: 'data',
            sortDesc: false,
            selectedAll: false,
            indeterminate: true,
            selectedCols: [
                'data',
                'unidade',
                'profissional',
                'cbo',
                'equipe',
                'atividade',
                'totalParticipantes',
                'totalPessoasAvaliadas'
            ],
            columns: [
                {
                    key: 'data',
                    label: 'Data',
                    sortable: true,
                    class: 'col-min',
                    formatter: value => this.formatDate(value),
                    filterByFormatted: true,
                    fixed: true,
                },
                { key: 'unidade', label: 'Unidade', sortable: true },
                { key: 'profissional', label: 'Profissional', sortable: true },
                { key: 'cbo', label: 'CBO', sortable: true },
                { key: 'equipe', label: 'Equipe', sortable: true },
                { key: 'atividade', label: 'Atividade', sortable: true },
                { key: 'totalParticipantes', label: 'Total de participantes', sortable: true },
                { key: 'totalPessoasAvaliadas', label: 'Total de pessoas avaliadas', sortable: true },     
                { key: 'localAtendimento', label: 'Local de Atendimento', sortable: true },   
                { key: 'cnes', label: 'CNES', sortable: true },     
                { key: 'turno', label: 'Turno', sortable: true },     
                { key: 'publicoAlvo', label: 'Público alvo', sortable: true },    
                { key: 'temaSaude', label: ' Temas para saúde', sortable: true },     
                { key: 'praticaSaude', label: 'Práticas em saúde', sortable: true },  
                { key: 'procedimentosVinculados', label: 'Procedimentos', sortable: true },
                { key: 'actions', label: 'Ações', fixed: true },
            ]
        }
    },
    methods: {
        ...mapActions(["setLoading", "unsetLoading"]),
        load(){
            this.setLoading()
            this.repositories.relatorioAtividadeColetiva.index()
                .then(({data}) =>{
                    this.form = data.form
                    this.model = { ...this.model, ...data.model }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        openScreen(item){
            let params = {
                name: 'atencao-basica-atividade-coletiva-edit',
                params: {id: item.id},
            }
            const route = this.$router.resolve(params)
            window.open(route.href, '_blank')
        },  
        
        getPses(){
            this.setLoading()
            this.repositories.relatorioAtividadeColetiva.getPses({
                periodo:{
                    data_inicial: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    data_final: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                }
            }).then(({data}) =>{
                this.pseItens = data.itens

                if (this.pseItens.length === 1) {
                    this.model.pseId = this.pseItens[0].id
                } else {
                    this.model.pseId = null
                }
                this.getTurnos()
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },

        getTurnos(){

            this.setLoading()
            this.repositories.relatorioAtividadeColetiva.getTurnos({
                periodo:{
                    data_inicial: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    data_final: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                pse_id: this.model.pseId,
            }).then(({data}) =>{

                this.turnoItens = data.itens

                if (this.turnoItens.length === 1) {
                    this.model.turnoId = this.turnoItens[0].id
                } else {
                    this.model.turnoId = null
                }
                this.getUnidades()
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },

        getUnidades(){
            this.setLoading()
            this.repositories.relatorioAtividadeColetiva.getUnidades({
                periodo:{
                    data_inicial: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    data_final: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                pse_id: this.model.pseId,
                turno_id: this.model.turnoId,
            }).then(({data}) =>{
                this.unidadeItens = data.itens

                if (this.unidadeItens.length === 1) {
                    this.model.unidadeId = this.unidadeItens[0].id
                } else {
                    this.model.unidadeId = null
                }
                this.getLocaisAtendimentos()
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },

        getLocaisAtendimentos(){
            this.setLoading()
            this.repositories.relatorioAtividadeColetiva.getLocaisAtendimentos({
                periodo:{
                    data_inicial: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    data_final: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                pse_id: this.model.pseId,
                turno_id: this.model.turnoId,
                unidade_id: this.model.unidadeId,

            }).then(({data}) =>{

                this.localAtendimentoItens = data.itens

                if (this.localAtendimentoItens.length === 1) {
                    this.model.localAtendimentoId = this.localAtendimentoItens[0].id
                } else {
                    this.model.localAtendimentoId = null
                }
                this.getProfissionais()
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },

        getProfissionais(){
            this.setLoading()
            this.repositories.relatorioAtividadeColetiva.getProfissionais({
                periodo:{
                    data_inicial: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    data_final: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                pse_id: this.model.pseId,
                turno_id: this.model.turnoId,
                unidade_id: this.model.unidadeId,
                local_atendimento_id: this.model.localAtendimentoId

            }).then(({data}) =>{

                this.profissionalItens = data.itens

                if (this.profissionalItens.length === 1) {
                    this.model.profissionalId = this.profissionalItens[0].id
                } else {
                    this.model.profissionalId = null
                }
                this.getOcupacoes()
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        getOcupacoes(){
            this.setLoading()
            this.repositories.relatorioAtividadeColetiva.getOcupacoes({
                periodo:{
                    data_inicial: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    data_final: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                pse_id: this.model.pseId,
                turno_id: this.model.turnoId,
                local_atendimento_id: this.model.localAtendimentoId,
                profissional_id: this.model.profissionalId

            }).then(({data}) =>{

                this.ocupacaoItens = data.itens

                if (this.ocupacaoItens.length === 1) {
                    this.model.ocupacaoId = this.ocupacaoItens[0].id
                } else {
                    this.model.ocupacaoId = null
                }
                this.getEquipes()
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        getEquipes(){
            this.setLoading()
            this.repositories.relatorioAtividadeColetiva.getEquipes({
                periodo:{
                    data_inicial: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    data_final: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                pse_id: this.model.pseId,
                turno_id: this.model.turnoId,
                local_atendimento_id: this.model.localAtendimentoId,
                profissional_id: this.model.profissionalId,
                ocupacao_id: this.model.ocupacaoId

            }).then(({data}) =>{

                this.equipeItens = data.itens

                if (this.equipeItens.length === 1) {
                    this.model.equipeId = this.equipeItens[0].id
                } else {
                    this.model.equipeId = null
                }

                this.getAtividades()
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        getAtividades(){
            this.setLoading()
            this.repositories.relatorioAtividadeColetiva.getAtividades({
                periodo:{
                    data_inicial: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    data_final: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                pse_id: this.model.pseId,
                turno_id: this.model.turnoId,
                local_atendimento_id: this.model.localAtendimentoId,
                profissional_id: this.model.profissionalId,
                ocupacao_id: this.model.ocupacaoId,
                equipe_id: this.model.equipeId

            }).then(({data}) =>{

                this.atividadeItens = data.itens

                if (this.atividadeItens.length === 1) {
                    this.model.atividadeId = this.atividadeItens[0].id
                } else {
                    this.model.atividadeId = null
                }
                this.getPublicosAlvo()
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        getPublicosAlvo(){
            this.setLoading()
            this.repositories.relatorioAtividadeColetiva.getPublicosAlvo({
                periodo:{
                    data_inicial: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    data_final: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                pse_id: this.model.pseId,
                turno_id: this.model.turnoId,
                local_atendimento_id: this.model.localAtendimentoId,
                profissional_id: this.model.profissionalId,
                ocupacao_id: this.model.ocupacaoId,
                equipe_id: this.model.equipeId

            }).then(({data}) =>{

                this.publicoAlvoItens = data.itens

                if (this.publicoAlvoItens.length === 1) {
                    this.model.publicoAlvoIds = [this.publicoAlvoItens[0].id]
                } else {
                    this.model.publicoAlvoIds = []
                }

                this.getTemasSaude()
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())            
        },
        getTemasSaude(){
            this.setLoading()
            this.repositories.relatorioAtividadeColetiva.getTemasSaude({
                periodo:{
                    data_inicial: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    data_final: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                pse_id: this.model.pseId,
                turno_id: this.model.turnoId,
                local_atendimento_id: this.model.localAtendimentoId,
                profissional_id: this.model.profissionalId,
                ocupacao_id: this.model.ocupacaoId,
                equipe_id: this.model.equipeId,
                publico_alvo_ids: this.model.publicoAlvoIds

            }).then(({data}) =>{
                this.temaSaudeItens = data.itens

                if (this.temaSaudeItens.length === 1) {
                    this.model.temaSaudeIds = [this.temaSaudeItens[0].id]
                } else {
                    this.model.temaSaudeIds = []
                }
                if (!this.praticaSaudeDisabled) {
                    this.getPraticasSaude()
                } else {
                    this.model.praticaSaudeIds = []
                    this.praticaSaudeItens = []
                    this.getProcedimentos()
                }
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        getPraticasSaude(){
            this.setLoading()
            this.repositories.relatorioAtividadeColetiva.getPraticasSaude({
                periodo:{
                    data_inicial: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    data_final: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                pse_id: this.model.pseId,
                turno_id: this.model.turnoId,
                local_atendimento_id: this.model.localAtendimentoId,
                profissional_id: this.model.profissionalId,
                ocupacao_id: this.model.ocupacaoId,
                equipe_id: this.model.equipeId,
                publico_alvo_ids: this.model.publicoAlvoIds,
                saude_tema_ids: this.model.temaSaudeIds
            }).then(({data}) =>{
                this.praticaSaudeItens = data.itens

                if (this.praticaSaudeItens.length === 1) {
                    this.model.praticaSaudeIds = [this.praticaSaudeItens[0].id]
                } else {
                    this.model.praticaSaudeIds = []
                }
                this.getProcedimentos()
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())    
        },
        getProcedimentos(){
            this.setLoading()
            this.repositories.relatorioAtividadeColetiva.getProcedimentos({
                periodo:{
                    data_inicial: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    data_final: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                pse_id: this.model.pseId,
                turno_id: this.model.turnoId,
                local_atendimento_id: this.model.localAtendimentoId,
                profissional_id: this.model.profissionalId,
                ocupacao_id: this.model.ocupacaoId,
                equipe_id: this.model.equipeId,
                publico_alvo_ids: this.model.publicoAlvoIds,
                saude_tema_ids: this.model.temaSaudeIds,
                pratica_saude_ids: this.model.praticaSaudeIds
            }).then(({data}) =>{
                this.procedimentoItens = data.itens
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())  
        },

        search(){
            this.$refs.Form.validate().then(valid => {
                if(!valid) return
                this.setLoading()

                this.repositories.relatorioAtividadeColetiva.list(this.prepareDate()).then(({data}) =>{
                    this.itens = data.itens
                    this.totalizadores = data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
            }

        )},
        limpar() {
            this.model = {
                periodo: { start: null, end: null },
                pseId: null,
                turnoId: null,
                inep: null,
                unidadeId: null,
                localAtendimentoId: null,
                profissionalId: null,
                ocupacaoId: null,
                equipeId: null,
                atividadeId: null,
                paciente: null,
                publicoAlvoIds: [],
                temaSaudeIds: [],
                praticaSaudeIds: [],
                procedimentoIds: [],
                avaliacaoAlterada: false,
                parouDeFumar: false,
                abandonouGrupo: false,
            }
            this.turnoItens = []
            this.unidadeItens = []
            this.localAtendimentoItens = []
            this.profissionalItens = []
            this.ocupacaoItens = []
            this.equipeItens = []
            this.atividadeItens = []
            this.publicoAlvoItens = []
            this.temaSaudeItens = []
            this.praticaSaudeItens = []
            this.procedimentoItens = []
            this.itens = []
            this.totalizadores = []
        },
        prepareDate(){
            return {
                periodo:{
                    data_inicial: moment(this.model.periodo.start).format('DD/MM/YYYY'),
                    data_final: moment(this.model.periodo.end).format('DD/MM/YYYY'),
                },
                pse_id: this.model.pseId,
                inep: this.model.inep,
                turno_id: this.model.turnoId,
                unidade_id: this.model.unidadeId,
                local_atendimento_id: this.model.localAtendimentoId,
                profissional_id: this.model.profissionalId,
                publico_alvo_id: this.model.publicoAlvoIds,
                saude_tema_id: this.model.temaSaudeIds,
                pratica_saude_id:this.model.praticaSaudeIds,
                procedimento_id: this.model.procedimentoIds,
                paciente_id: this.model.paciente?.id,
                avaliacao_alterada: this.model.avaliacaoAlterada || null,
                parou_de_fumar: this.model.parouDeFumar || null,
                abandonou_grupo: this.model.abandonouGrupo || null,
                sort_by: this.sortBy,
                sort_desc: this.sortDesc,
            }
        },
        print() {
            this.setLoading()
            const sorted = [...this.itens].sort((a, b) => {
                const valA = a[this.sortBy] ?? ''
                const valB = b[this.sortBy] ?? ''
                const cmp = String(valA).localeCompare(String(valB), undefined, { numeric: true })
                return this.sortDesc ? -cmp : cmp
            })
            this.repositories.impressao.relatorioAtividadeColetiva({
                itens: sorted,
                totalizadores: this.totalizadores,
                colunas: this.fields.map(f => f.key),
                filtros: this.filtrosImpressao,
            })
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        exportar() {
            this.setLoading()
            const params = {
                ...this.prepareDate(),
                sort_by: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                colunas: this.fields.map(f => f.key),
                filtros: this.filtrosImpressao,
            }
            this.repositories.exportacao.relatorioAtividadeColetiva(params)
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        onSortChanged({ sortBy, sortDesc }) {
            this.sortBy = sortBy
            this.sortDesc = sortDesc
        },
        selectAll(selected) {
            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
    },
    mixins: [ repository, formats, file, stringCase, permissao ],
    watch: {
        selectedCols(newValue) {
            this.selectedAll = newValue.length > 0 && newValue.length === this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length !== this.optionalColumns.length
        },
        'model.periodo.start' () {
            if(this.model.periodo.start && this.model.periodo.end) {
                this.getPses()
            }
        },
        'model.periodo.end' () {
            if(this.model.periodo.end && this.model.periodo.start) {
                this.getPses()
            }
        },

    }
}
</script>